import {atom} from 'recoil';

interface LegalEntity {
    id: string;
    name: string;
}

interface Dealer {
    id: string;
    name: string;
    legalEntity: LegalEntity;
}

interface Department {
    id: string;
    name: string;
}

interface Profile {
    id: string;
    name: string;
}

interface Auth {
    id: string;
    name: string;
}

interface OperatorDetailStructure {
    legalEntityDtos: LegalEntity[];
    dealerDtos: Dealer[];
    departmentDtos: Department[];
    profileDtos: Profile[];
    authDtos: Auth[];
}

const defaultList: any[] = [];
export const operatorList = atom({
    key: 'operatorList',
    default: defaultList
});

export const operatorFromValues: any = atom({
    key: 'operatorFromValues',
    default: null
});

export const operatorDetailStructure = atom({
    key: 'operatorDetailStructure',
    default: {
        legalEntityDtos: [],
        dealerDtos: [],
        departmentDtos: [],
        profileDtos: [],
        authDtos: [],
    } as OperatorDetailStructure
});
